import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/rejected.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const RejectedIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("path", { d: "M7.5 7.5l9 9M16.5 7.5l-9 9", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" })));
export const RejectedIcon = createIcon(RejectedIconGlyph, "RejectedIcon", "0 0 24 24");
//# sourceMappingURL=RejectedIcon.js.map